
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.0791 3.48926C6.62682 3.48926 3 7.11484 3 11.5657C3 16.0165 6.62682 19.6491 11.0791 19.6491C12.9809 19.6491 14.7299 18.9829 16.1122 17.8767L19.4775 21.2391C19.6473 21.4018 19.8741 21.4916 20.1094 21.4892C20.3446 21.4868 20.5695 21.3924 20.736 21.2262C20.9025 21.0601 20.9972 20.8354 20.9999 20.6002C21.0027 20.3651 20.9132 20.1382 20.7506 19.9682L17.3853 16.604C18.4928 15.2201 19.16 13.4689 19.16 11.5657C19.16 7.11484 15.5315 3.48926 11.0791 3.48926ZM11.0791 5.28443C14.561 5.28443 17.3625 8.08503 17.3625 11.5657C17.3625 15.0463 14.561 17.8539 11.0791 17.8539C7.59732 17.8539 4.79575 15.0463 4.79575 11.5657C4.79575 8.08503 7.59732 5.28443 11.0791 5.28443Z","fill":"#1C1D20"}})])
          )
        }
      }
    